



















import Vue from 'vue'
import { ItemPdfElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ItemPdfEl',

  computed: {
    addBorder (): string {
      if (!this.templateItemData.separator) {
        return ''
      }
      return `border-bottom: 1px solid ${this.templateItemData.separator};`
    }
  },

  methods: {
    downloadPdf () {
      if (Object.prototype.hasOwnProperty.call(this.templateItemData, 'pdfUri')) {
        window.open(this.templateItemData.pdfUri, '_blank')
      }
    },
    openPage () {
      if (
        Object.prototype.hasOwnProperty.call(this.templateItemData, 'uri') &&
        Object.prototype.hasOwnProperty.call(this.templateItemData, 'view')
      ) {
        return this.getView(this.templateItemData.view, this.templateItemData.uri)
      }
    }
  },

  props: {
    templateItemData: {
      type: Object as () => ItemPdfElInterface,
      required: true
    }
  }
})
